import { Outlet } from "react-router-dom";
import logo from "../assets/images/logo1.png";
const AuthLayout = () => {
  return (
    <main className="d-flex flex-column min-vh-100">
      <Outlet />
      <footer
        style={{ backgroundColor: "#303C54" }}
        className="px-3 py-1 text-white  d-flex justify-content-between align-items-center"
      >
        <img src={logo} alt="Logo" width="100" />
        <small>© 2024</small>
      </footer>
    </main>
  );
};

export default AuthLayout;
